import { focusElement } from 'platform/utilities/ui';
import { useEffect } from 'react';

/**
 * Applies initial focus when a custom route loads.
 * additionalRoutes do not use FormPage's built-in focus behavior.
 */
export const useRouteFocusOnLoad = (
  selector = 'h1[data-testid="form-title"]',
) => {
  useEffect(() => focusElement(selector), [selector]);
};
